// biome-ignore lint/style/noEnum: TODO: review this suppression
export enum UrlParameterKeys {
    ASSET_IDS = 'assetIds',
    RESOURCE_IDS = 'resourceIds',
    PRODUCT_ID = 'productId',
    POPUP = 'popup',
    LEVEL = 'level',
    LOCKED = 'locked',
    INTERNAL_CAMPAIGN = 'internalCampaign',
}
